<h2 mat-dialog-title>{{ data?.id ? 'Edit Role' : 'Create Role' }}</h2>

<mat-dialog-content>
   <!-- Add a loading spinner for initial data load -->
   <div *ngIf="initialLoading" class="flex justify-center items-center p-8">
    <mat-spinner diameter="50"></mat-spinner>
  </div>

  <form [formGroup]="form" *ngIf="!initialLoading">
    <mat-form-field appearance="outline" class="w-full">
      <mat-label>Role Name</mat-label>
      <input matInput formControlName="name" />
    </mat-form-field>

    <h3>Permissions</h3>
    <div class="permissions-grid">
      <div
        *ngFor="let p of permissions"
        class="permission-item"
      >
        <mat-checkbox
          [checked]="isPermissionSelected(p.id)"
          (change)="togglePermission(p.id, $event.checked)"
        >
          {{ p.name }}
        </mat-checkbox>
      </div>
    </div>
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="dialogRef.close()" [disabled]="loading">Cancel</button>
  <button mat-raised-button color="primary" (click)="save()" [disabled]="loading || initialLoading || form.invalid">
    <span *ngIf="loading">Saving...</span>
    <span *ngIf="!loading">Save</span>
  </button>
</mat-dialog-actions>
